import { render, staticRenderFns } from "./greet.vue?vue&type=template&id=695da5d1"
import script from "./greet.vue?vue&type=script&lang=js"
export * from "./greet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports